"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_acdc_1 = require("@seaweb/react-acdc");
var color_1 = require("@seaweb/coral/utils/color");
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var Dropdown_1 = __importDefault(require("@seaweb/coral/components/icons/Dropdown"));
var CancelSmall_1 = __importDefault(require("@seaweb/coral/components/icons/CancelSmall"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var Button_1 = __importStar(require("@seaweb/coral/components/Button/Button"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var SelectContext_1 = require("./SelectContext");
var baseStyle = styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 36px;\n  width: 40px;\n  padding: 0;\n  min-width: unset;\n  position: absolute;\n  transform: translateY(-50%);\n  top: 50%;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 36px;\n  width: 40px;\n  padding: 0;\n  min-width: unset;\n  position: absolute;\n  transform: translateY(-50%);\n  top: 50%;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var WrappedButton = forwardAs_1.default(Button_1.default);
var ClearButton = styled_1.default(WrappedButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  opacity: 0.3;\n\n  &[data-focus-visible-added],\n  &[data-coral-hover],\n  &:hover {\n    opacity: 1;\n  }\n"], ["\n  ", "\n  opacity: 0.3;\n\n  &[data-focus-visible-added],\n  &[data-coral-hover],\n  &:hover {\n    opacity: 1;\n  }\n"])), baseStyle);
var ArrowWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  pointer-events: none;\n"], ["\n  ", "\n  pointer-events: none;\n"])), baseStyle);
var ArrowIcon = styled_1.default(Dropdown_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  box-sizing: content-box;\n  opacity: 0.3;\n  transition: transform 0.2s ease;\n\n  ", "\n"], ["\n  box-sizing: content-box;\n  opacity: 0.3;\n  transition: transform 0.2s ease;\n\n  ",
    "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      transform: rotate(180deg);\n    "], ["\n      transform: rotate(180deg);\n    "])));
});
var SelectArrowIcon = react_1.forwardRef(function SelectArrowIcon(_a, ref) {
    var as = _a.as, clearable = _a.clearable, onClick = _a.onClick, _b = _a.variant, variant = _b === void 0 ? Button_1.ButtonVariants.Text : _b, colorProp = _a.color, props = __rest(_a, ["as", "clearable", "onClick", "variant", "color"]);
    var _c = SelectContext_1.useSelectContext(), value = _c.value, setValue = _c.setValue;
    var _d = react_acdc_1.useAcdcContext(), isOpen = _d.state.isOpen, dispatch = _d.dispatch;
    var getInputElement = react_acdc_1.useAcdcElementRegistryContext().getInputElement;
    var clearing = clearable && value !== null;
    var handleClick = useWrapEvent_1.default(onClick, function (e) {
        e.stopPropagation();
        if (clearing) {
            dispatch({ type: react_acdc_1.ActionTypes.MergeState, state: { value: '' } });
            setValue(null);
            var input = getInputElement();
            if (input)
                input.focus();
        }
    });
    var colors = ThemeProvider_1.useThemeContext().colors;
    var color = fallback_1.default(colorProp, color_1.alp(colors.alternate, 0.6));
    if (clearing) {
        return (react_1.default.createElement(ClearButton, __assign({ _as: as, ref: ref, onClick: handleClick, variant: variant, color: color, "aria-label": "Clear selection" }, props),
            react_1.default.createElement(CancelSmall_1.default, { size: 12, "aria-hidden": true })));
    }
    return (react_1.default.createElement(ArrowWrapper, __assign({ as: as, ref: ref, onClick: handleClick, "data-coral-select-button-arrow-wrapper": "", "aria-hidden": true }, props),
        react_1.default.createElement(ArrowIcon, { isOpen: isOpen })));
});
exports.default = SelectArrowIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
